var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3853 21.4746L30.5396 3.32031C32.4927 1.36719 35.647 1.36719 37.6001 3.32031C39.5532 5.27344 39.5532 8.42773 37.6001 10.3809L22.9712 25L37.6001 39.6191C39.5532 41.5723 39.5532 44.7266 37.6001 46.6797C35.647 48.6328 32.4927 48.6328 30.5396 46.6797L12.3853 28.5254C10.4419 26.582 10.4419 23.418 12.3853 21.4746Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow-left.b9a9b4f901aa21f98a35826cd45716cd.svg";
export { ForwardRef as ReactComponent };